<template>
    <a-layout id="enterprise_send" class="page_layout page_tool">
        <a-layout-content class="page_content">
            <cTabs tabsType="line" :tabsData="tabsData" @backTabs="backTabs">
                <div class="tab_wrap" v-if="tabsCurr && tabsCurr.tabKey === 1">
                    <template v-if="!createBtn">
                        <div class="tab_title">
                            <a-alert :message="tabsCurr.tabDesc" type="info" />
                        </div>
                        <a-button type="primary" class="tab_btn" @click="createCode">
                            新建{{tabsCurr.tabName}}
                        </a-button>
                        <a-divider />
                        <!-- 自动拉群列表 -->
                        <div class="staff_list">
                            <div class="select_btn dir_left_wrap cross_center">
                                <!-- <div class="select_title">{{tabsCurr.tabName}}</div> -->
                                <a-range-picker @change="changeRangePicker" />
                                <div class="base_font_color_909399" style="padding-left: 15px;">起止时间不要超过1个月</div>
                                <!-- <div class="select_cont" style="margin-left: 1%; width: 240px;">
                                    <a-input placeholder="请输入消息内容" />
                                </div> -->
                                <!-- <a-button style="margin-left: 1%;">
                                    查询
                                </a-button> -->
                            </div>
                            <div class="table_data">
                                <a-table
                                    rowKey="id"
                                    :columns="sendColumns"
                                    :data-source="sendList"
                                    :loading="tableLoading"
                                    :pagination="sendPage"
                                    @change="changePagination"
                                >
                                    <template slot="content" slot-scope="text, record">
                                        {{text ? text : '未发文本消息'}}
                                    </template>
                                    <template slot="creator" slot-scope="text, record">
                                        <openData type="userName" :openid="text"></openData>
                                    </template>
                                    <template slot="chatType" slot-scope="text, record">
                                        <a-tag>{{text === 'single' ? '推送客户' : '推送客户群'}}</a-tag>
                                    </template>
                                    <template slot="mediaType" slot-scope="text, record">
                                        <a-tag v-if="text === 'text'">文本</a-tag>
                                        <a-tag v-else-if="text === 'image'">图片</a-tag>
                                        <a-tag v-else-if="text === 'link'">网页</a-tag>
                                        <a-tag v-else-if="text === 'voice'">语音</a-tag>
                                        <a-tag v-else-if="text === 'video'">视频</a-tag>
                                        <a-tag v-else-if="text === 'wxapp'">小程序</a-tag>
                                        <a-tag v-else>文件</a-tag>
                                    </template>
                                    <template slot="status" slot-scope="record">
                                        <a-button
                                            style="margin-left: -7px;"
                                            size="small" type="link"
                                            @click="sendDetail(record)"
                                        >
                                            未发送：{{record.status0Num}}；
                                            已发送：{{record.status1Num}}；
                                            不是好友失败：{{record.status2Num}}；
                                            已推送过失败：{{record.status3Num}}
                                        </a-button>
                                    </template>
                                    <template slot="action" slot-scope="text, record">
                                        <a-button-group style="margin-left: -7px;" class="cross_center">
                                            <a-button size="small" type="link" @click="refresh(record)" title="刷新推送状态">刷新</a-button>
                                        </a-button-group>
                                    </template>
                                </a-table>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <!-- 创建欢迎语 -->
                        <a-page-header
                            :title="
                                tabsCurr.createCodeData.sendId ? (tabsCurr.tabName + '详情') : ('新建' + tabsCurr.tabName)
                            "
                            @back="createBack"
                            class="edit_code_title"
                        />
                        <div class="edit_code_from">
                            <a-form-model
                                ref="ruleForm1"
                                :model="tabsCurr.createCodeData"
                                :rules="tabsCurr.fromRule"
                                :label-col="{ span: !tabsCurr.createCodeData.sendId ? 4 : 3 }"
                                :wrapper-col="{ span: !tabsCurr.createCodeData.sendId ? 20 : 21 }"
                                labelAlign="left"
                            >
                                <div class="main_between cross_top">
                                    <div class="left_col">
                                        <template v-if="!tabsCurr.createCodeData.sendId">
                                            <a-form-model-item label="群发类型" prop="chatType">
                                                <a-radio-group v-model="tabsCurr.createCodeData.chatType">
                                                    <a-radio value="single">
                                                        发送给客户
                                                    </a-radio>
                                                    <!-- <a-radio value="group">
                                                        发送给客户群
                                                    </a-radio> -->
                                                </a-radio-group>
                                            </a-form-model-item>
                                            <a-form-model-item label="发送范围" prop="sendRangeType">
                                                <a-radio-group v-model="tabsCurr.createCodeData.sendRangeType" @change="radioChange">
                                                    <a-radio value="1">
                                                        全部客户
                                                    </a-radio>
                                                    <a-radio value="2">
                                                        按条件筛选客户
                                                    </a-radio>
                                                </a-radio-group>
                                                <div class="select_customer" v-if="tabsCurr.createCodeData.sendRangeType === '2'">
                                                    <div class="select_list cross_center">
                                                        <div class="title base_font_color_909399">标签筛选：</div>
                                                        <a-button @click="toOpen('tags')">
                                                            添加
                                                        </a-button>
                                                        <tagModal
                                                            ref="tags"
                                                            :selectKey="tabsCurr.createCodeData.tagId"
                                                            @change="backTagList"
                                                        />
                                                    </div>
                                                    <div
                                                        class="dir_left_wrap cross_center"
                                                        v-if="
                                                            tabsCurr.createCodeData.tagId &&
                                                                tabsCurr.createCodeData.tagId
                                                                    .length > 0
                                                        "
                                                    >
                                                        <div
                                                            class="title base_font_color_909399"
                                                        >
                                                            已选标签：
                                                        </div>
                                                        <template
                                                            v-for="(item, index) in tabsCurr
                                                                .createCodeData.tagId"
                                                        >
                                                            <a-tag
                                                                :key="index"
                                                                @click="tagClose('tagId', index)"
                                                            >
                                                                {{ item.tagName }}
                                                                <a-icon type="close" />
                                                            </a-tag>
                                                        </template>
                                                    </div>
                                                    <div class="select_list cross_center">
                                                        <div class="title base_font_color_909399">员工筛选：</div>
                                                        <a-button class="staff_add" @click="toOpen('contacts')">
                                                            添加
                                                        </a-button>
                                                        <contactsModal
                                                            ref="contacts"
                                                            :title="['组织架构', '已选择成员']"
                                                            backFunctionName="backUserList"
                                                            type="single"
                                                            :backFunctionData="true"
                                                            @backUserList="backUserList"
                                                        ></contactsModal>
                                                    </div>
                                                    <div
                                                        class="dir_left_wrap cross_center"
                                                        v-if="
                                                            tabsCurr.createCodeData.userId &&
                                                                tabsCurr.createCodeData.userId.length > 0
                                                        "
                                                    >
                                                        <div
                                                            class="title base_font_color_909399"
                                                        >
                                                            已选人员：
                                                        </div>
                                                        <template
                                                            v-for="(item, index) in tabsCurr.createCodeData
                                                                .userId"
                                                        >
                                                            <a-tag
                                                                :key="index"
                                                                @click="tagClose('userId', index)"
                                                            >
                                                                <openData type="userName" :openid="item"></openData>
                                                                <a-icon type="close" />
                                                            </a-tag>
                                                        </template>
                                                    </div>
                                                </div>
                                            </a-form-model-item>
                                            <!-- <a-form-model-item label="发送时间" prop="sendTime">
                                                <div class="dir_left_wrap cross_center">
                                                    <a-date-picker
                                                        format="YYYY-MM-DD HH:mm:ss"
                                                        :disabled-date="disabledDate"
                                                        :disabled-time="disabledDateTime"
                                                        :show-time="{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }"
                                                    />
                                                    <span class="base_font_size_12 base_font_color_909399" style="padding-left: 20px;">
                                                        设置时间定时发送，不设立即发送
                                                    </span>
                                                </div>
                                            </a-form-model-item> -->
                                            <a-form-model-item label="群发推送" prop="content">
                                                <div class="welcome_container">
                                                    <wxWelcomeEdit
                                                        placeholder="输入消息内容"
                                                        :changeParams="['content']"
                                                        :data="tabsCurr.createCodeData"
                                                        :dataStyle="{ backgroundColor: '#fafafa', borderRadius: '5px', padding: '15px' }"
                                                        :limitShow="false"
                                                        @backTextarea="backTextarea"
                                                        @backWelcomeData="backWelcomeData"
                                                        @backCurrData="backCurrData"
                                                        style="margin-top: 16px;margin-bottom: 16px;"
                                                    >
                                                    </wxWelcomeEdit>
                                                </div>
                                            </a-form-model-item>
                                        </template>
                                        <template v-else>
                                            <div class="send_detail">
                                                <a-form-model-item label="创建人">
                                                    <openData type="userName" :openid="recordDetail.creator"></openData>
                                                </a-form-model-item>
                                                <a-form-model-item label="创建时间">
                                                    {{recordDetail.createTime}}
                                                </a-form-model-item>
                                                <a-form-model-item label="群发类型">
                                                    {{recordDetail.chatType === 'single' ? '推送客户' : '推送客户群'}}
                                                </a-form-model-item>
                                                <a-form-model-item label="发送内容">
                                                    {{recordDetail.content}}
                                                </a-form-model-item>
                                                <a-divider />
                                                <a-tabs type="card" :animated="true">
                                                    <template v-for="(item, index) in statusTab">
                                                        <a-tab-pane :key="index" :tab="item.tabName">
                                                            <a-table
                                                                :rowKey="item.index"
                                                                :columns="item.columns"
                                                                :data-source="statusDetail['status' + item.status + '']"
                                                                :pagination="false"
                                                            >
                                                                <template slot="userid" slot-scope="text">
                                                                    <openData type="userName" :openid="text"></openData>
                                                                </template>
                                                            </a-table>
                                                        </a-tab-pane>
                                                    </template>
                                                </a-tabs>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="right_col">
                                        <wxWelcome
                                            :chatName="{headTitle: '企业群名称', footTitle: '企业群发样式'}"
                                            :data="welcomeDataComputed"
                                        ></wxWelcome>
                                    </div>
                                </div>
                            </a-form-model>
                            <a-affix class="affix_style" :offset-bottom="80" @change="affixChange">
                                <div class="from_btn main_between cross_top" :class="[!affixed ? 'from_btn_fix' : '']">
                                    <div class="left_col dir_left_wrap cross_center">
                                        <a-button type="primary" style="margin-right: 10px;" @click="createNew" v-if="!tabsCurr.createCodeData.sendId">
                                            通知成员发送
                                        </a-button>
                                        <a-button @click="createBack">
                                            {{tabsCurr.createCodeData.sendId ? '返回' : '取消'}}
                                        </a-button>
                                        <span class="base_font_size_12 base_font_color_909399" style="padding-left: 20px;" v-if="!tabsCurr.createCodeData.sendId">
                                            通知成员，向选中客户发送以上消息
                                        </span>
                                    </div>
                                    <div class="right_col"></div>
                                </div>
                            </a-affix >
                        </div>
                    </template>
                </div>
                <a-layout-content class="page_content tool_content wait_content main_center cross_center" v-else>
                    <a-empty description="敬请期待" />
                </a-layout-content>
            </cTabs>
        </a-layout-content>
    </a-layout>
</template>

<script>
import api from '@/apis';
import _ from 'lodash';
import dayjs from 'dayjs';
import cTabs from '@/components/common/ant/c_tabs';
import wxWelcome from '@/components/common/base/wx_welcome';
import wxWelcomeEdit from '@/components/common/base/wx_welcome_edit';
import openData from '@/components/group/openData';
import tagModal from '@/components/group/tagModal';
import contactsModal from '@/components/group/contactsModal';
export default {
    name: 'enterprise_send',
    components: {
        cTabs,
        wxWelcome,
        wxWelcomeEdit,
        openData,
        tagModal,
        contactsModal
    },
    data() {
        return {
            // tabs数据
            tabsData: [
                {
                    tabKey: 1,
                    tabType: '',
                    tabName: '企业群发',
                    tabDesc: '由添加客户的成员确认后发送给客户或由群主确认后发送给客户群。',
                    tabDisabled: false,
                    createCodeData: {
                        // 群发记录id
                        sendId: null,
                        // 群发类型
                        chatType: 'single',
                        // 创建人userid
                        creator: window.sessionStorage.getItem('userName'),
                        // 发送范围
                        sendRangeType: '1',
                        externalId: [],
                        // 客户标签
                        tagId: [],
                        // 客户管理员工id
                        userId: [],
                        // 发送时间
                        // sendTime: null,
                        // 发送内容
                        content: "",
                        // 素材类型 'text', 'image', 'voice', 'video', 'file', 'link', 'wxapp'
                        mediaType: null,
                        // 素材id
                        materialId: null,
                        // 当前素材信息
                        materialItem: null,
                        // 发送企业群发消息的成员userid
                        sender: ''
                    },
                    fromRule: {
                        sendRangeType: [{ required: true, message: '请选择发送范围', trigger: 'change' }],
                        content: [{ required: true, message: '请输入发送内容', trigger: 'change' }],
                    }
                },
            ],
            // 当前tab数据
            tabsCurr: null,
            // 新建自动拉群
            createBtn: false,
            // 欢迎语模版相关
            tableLoading: false,
            sendList: [],
            sendParams: {
                page: 1,
                // chatType: null,
                // creator: null,
                // mediaType: null,
                // startTime: null,
                // endTime: null
            },
            sendPage: {
                total: 0,
                pageSize: 10
            },
            sendColumns: [
                {
                    title: '消息内容',
                    dataIndex: 'content',
                    scopedSlots: { customRender: 'content' },
                },
                {
                    title: '创建人',
                    dataIndex: 'creator',
                    scopedSlots: { customRender: 'creator' },
                },
                {
                    title: '群发类型',
                    dataIndex: 'chatType',
                    scopedSlots: { customRender: 'chatType' },
                },
                {
                    title: '素材类型',
                    dataIndex: 'mediaType',
                    scopedSlots: { customRender: 'mediaType' },
                },
                {
                    title: '推送状态',
                    scopedSlots: { customRender: 'status' },
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    width: 80,
                },
            ],
            // 传递入群引导语
            welcomeData: [],
            // 图钉
            affixed: false,
            // 客户传参参数
            customerParams: {
                page: 1,
                userId: [],
                tagId: [],
                getAll: 1
            },
            // 记录详情
            statusTab: [{status: '0', tabName: '待发送'}],
            statusDetail: {},
            recordDetail: null,
        }
    },
    computed: {
        welcomeDataComputed() {
            return this.welcomeData;
        }
    },
    mounted() {
        // 初始
        this.tabsData.forEach((item, index) => {
            if (index === 0) {
                this.tabsCurr = item;
            }
        });
        this.getSendList();
    },
    watch: {},
    methods: {
        // Tabs接收子组件数据
        backTabs(data) {
            this.tabsData.forEach(item => {
                if (item.tabKey === data) {
                    this.tabsCurr = item;
                }
            })
        },
        // 创建
        createCode() {
            this.createBtn = !this.createBtn;
            this.tabsData.forEach(item => {
                if (this.tabsCurr.tabKey !== item.tabKey) item.tabDisabled = !item.tabDisabled;
                return item;
            });
            if (this.tabsCurr.createCodeData.sendRangeType === '1') this.getCustomerList();
        },
        // 返回 / 取消
        createBack() {
            // 恢复初始数据
            this.createBtn = !this.createBtn;
            this.tabsData.forEach(item => {
                item.tabDisabled = false;
                return item;
            });
            // 用于清空恢复初始数据
            let tabsDataClear = [
                {
                    tabKey: 1,
                    tabType: '',
                    tabName: '企业群发',
                    tabDesc: '由添加客户的成员确认后发送给客户或由群主确认后发送给客户群。',
                    tabDisabled: false,
                    createCodeData: {
                        // 群发记录id
                        sendId: null,
                        // 群发类型
                        chatType: 'single',
                        // 创建人userid
                        creator: window.sessionStorage.getItem('userName'),
                        // 发送范围
                        sendRangeType: '1',
                        externalId: [],
                        // 客户标签
                        tagId: [],
                        // 客户管理员工id
                        userId: [],
                        // 发送时间
                        // sendTime: null,
                        // 发送内容
                        content: "",
                        // 素材类型 'text', 'image', 'voice', 'video', 'file', 'link', 'wxapp'
                        mediaType: null,
                        // 素材id
                        materialId: null,
                        // 当前素材信息
                        materialItem: null,
                        // 发送企业群发消息的成员userid
                        sender: ''
                    },
                    fromRule: {
                        sendRangeType: [{ required: true, message: '请选择发送范围', trigger: 'change' }],
                        content: [{ required: true, message: '请输入发送内容', trigger: 'change' }],
                    }
                },
            ];
            tabsDataClear.forEach(item => {
                if (item.tabKey === this.tabsCurr.tabKey) this.tabsCurr = item;
            });
            this.statusTab = [{status: '0', tabName: '待发送'}];
            this.statusDetail = {};
            this.recordDetail = null;
            this.welcomeData = [];
        },
        // 刷新状态
        async refresh(record) {
            if (!record) return;
            const res = await api.sendMessageRes({
                msgid: record.msgid,
                totalStatus: 1
            });
            if (res.code !== 0) return this.$message.error(`${res.code}-${res.msg}`);
            this.statusDetail = {};
            this.statusTab = Object.keys(res.statusList).map(key => {
                const item = { status: key };
                if (key === '0') item.tabName = '待发送（'+res.statusList[key].length+'）';
                else if (key === '1') item.tabName = '已发送（'+res.statusList[key].length+'）';
                else if (key === '2') item.tabName = '不是好友失败（'+res.statusList[key].length+'）';
                else if (key === '3') item.tabName = '已推送过失败（'+res.statusList[key].length+'）';
                if (key === '0') {
                    item.columns = [
                        {
                            title: '发送成员',
                            dataIndex: 'userid',
                            scopedSlots: { customRender: 'userid' },
                        },
                        {
                            title: '发送客户',
                            dataIndex: 'customer_name',
                        },
                    ]
                } else {
                    item.columns = [
                        {
                            title: '发送成员',
                            dataIndex: 'userid',
                            scopedSlots: { customRender: 'userid' },
                        },
                        {
                            title: '发送客户',
                            dataIndex: 'customer_name',
                        },
                        {
                            title: '发送时间',
                            dataIndex: 'send_time',
                            width: 200
                        },
                    ]
                }
                this.statusDetail['status' + key] = res.statusList[key];
                return item;
            });
            this.getSendList();
        },
        // 获取群发记录
        async getSendList() {
            try {
                this.tableLoading = true;
                const res = await api.getMessageList(this.sendParams);
                if (res.code !== 0) {
                    this.tableLoading = false;
                    return this.$message.error(`${res.code}-${res.msg}`);
                }
                setTimeout(() => {
                    this.tableLoading = false;
                    this.sendList = res.rows;
                    this.sendPage = {
                        total: res.count,
                        pageSize: res.pageSize
                    }
                }, 500);
            } catch (err) {
                console.log(err);
                this.tableLoading = false;
                this.sendList = [];
                this.sendPage = {
                    total: 0,
                    pageSize: 10
                }
            }
        },
        affixChange() {
            this.affixed = !this.affixed;
        },
        // [员工码]获取子组件数据
        backTextarea(subName1, subValue1, subName2, subValue2) {
            this.tabsCurr.createCodeData[subName1] = subValue1;
            this.tabsCurr.createCodeData[subName2] = subValue2;
        },
        backWelcomeData(welcomeData) {
            this.welcomeData = welcomeData;
        },
        backCurrData(backCurrData) {
            const currData = this.tabsCurr.createCodeData;
            if (backCurrData) {
                currData.mediaType = backCurrData.mediaType;
                currData.materialId = backCurrData.id;
                currData.materialItem = backCurrData;
            } else {
                currData.mediaType = null;
                currData.materialId = null;
                currData.materialItem = null;
            }
        },
        // 生成
        async createNew() {
            try {
                const dataCurr = this.tabsCurr.createCodeData;
                if (!dataCurr.creator) return;
                const params = {
                    creator: dataCurr.creator
                }
                if (dataCurr.chatType) params.chatType = dataCurr.chatType;
                if (dataCurr.externalId && dataCurr.externalId.length > 0) params.externalId = dataCurr.externalId;
                if (dataCurr.sender) params.sender = dataCurr.sender;
                if (dataCurr.mediaType) params.mediaType = dataCurr.mediaType;
                if (dataCurr.materialId) params.materialId = dataCurr.materialId;
                if (dataCurr.content) params.text = { content: dataCurr.content };
                if (dataCurr.materialItem) {
                    const material = dataCurr.materialItem;
                    // 图片素材赋值
                    if (material.mediaType === "image" && !material.url) return this.$message.warning('图片地址不能为空');
                    if (material.mediaType === "image" && material.url) params.image = {
                        picUrl: material.url
                    };
                    // 网页素材赋值
                    if (material.mediaType === "link" && (!material.url || !material.title)) return this.$message.warning('网页链接和标题不能为空');
                    if (material.mediaType === "link" && material.url && material.title) {
                        params.link = {
                            title: material.title,
                            url: material.url
                        };
                        if (material.description) params.link.desc = material.description;
                        if (material.cover) params.link.picurl = material.cover;
                    }
                    // 小程序素材赋值
                    if (material.mediaType === "wxapp" && (!material.mediaId || !material.appId || !material.appPage || !material.title)) return this.$message.warning('小程序标题、封面的mediaid、appid、page路径不能为空');
                    if (material.mediaType === "wxapp" && material.mediaId && material.appId && material.appPage && material.title) {
                        params.miniprogram = {
                            title: material.title,
                            picMediaId: material.mediaId,
                            appid: material.appId,
                            page: material.appPage
                        };
                    }
                }
                const res = await api.sendMessage(params);
                if (res.code !== 0) return this.$message.error(`${res.code}-${res.msg}`);
                this.$message.success('成功新建企业群发任务');
                this.createBack();
                this.getSendList();
            } catch (err) {
                console.log(err);
            }
        },
        // 时间筛选
        dayjs,
        range(start, end) {
            const result = [];
            for (let i = start; i < end; i++) {
                result.push(i);
            }
            return result;
        },
        disabledDate(current) {
            // Can not select days before today and today
            return current && current < dayjs().subtract(1, 'day').endOf('day');
        },
        disabledDateTime() {
            // console.log('disabledDateTime', this.range(0, 24).splice(4, 20));
            return {
                disabledHours: () => [],
                disabledMinutes: () => [],
                disabledSeconds: () => [],
            };
        },
        // 日期筛选
        changeRangePicker(date, dateString) {
            console.log(date, dateString);
            if (_.compact(dateString).length > 0) {
                this.sendParams.startTime = dateString[0];
                this.sendParams.endTime = dateString[1];
            } else {
                delete this.sendParams.startTime;
                delete this.sendParams.endTime;
            }
            this.getSendList();
        },
        // 客户列表
        async getCustomerList() {
            try {
                const currData = this.tabsCurr.createCodeData;
                const res = await api.postContactSearch(this.customerParams);
                if (res.code !== 0) return this.$message.error(`${res.code}-${res.msg}`);
                if (res.rows && res.rows.length === 0) return this.$message.warning('发送范围为空，请重新选择条件');
                currData.externalId = _.map(res.rows, 'id');
            } catch (err) {
                console.log(err);
            }
        },
        // 客户范围选择
        radioChange(e) {
            const currData = this.tabsCurr.createCodeData;
            currData.sendRangeType === e.target.value;
            if (e.target.value === '1') {
                currData.userId = [];
                currData.tagId = [];
                this.customerParams = {
                    page: 1,
                    userId: [],
                    tagId: [],
                    getAll: 1
                }
                this.getCustomerList();
            }
        },
        // 开启
        toOpen(type) {
            if (!type) return;
            this.$refs[type].open();
        },
        // 标签回调
        backTagList(data) {
            this.tabsCurr.createCodeData.tagId = data;
            this.customerParams.tagId = _.map(data, 'tagId');
            this.getCustomerList();
        },
        // 关闭标签
        tagClose(type, index) {
            const dataCurr = this.tabsCurr.createCodeData;
            dataCurr[type].splice(index, 1);
            this.customerParams[type].splice(index, 1);
            this.getCustomerList();
        },
        // 使用员工回调
        backUserList(userList) {
            const dataCurr = this.tabsCurr.createCodeData;
            if (userList && userList.dataName) {
                userList.dataName.forEach((item) => {
                    if (Object.prototype.toString.call(item) === '[object String]') {
                        if (_.indexOf(dataCurr.userId, item) < 0) dataCurr.userId.push(item);
                        if (_.indexOf(this.customerParams.userId, item) < 0) this.customerParams.userId.push(item);
                    }
                });
                this.getCustomerList();
            }
        },
        // 企业群发详情
        sendDetail(record) {
            if (!record) return;
            this.refresh(record);
            const dataCurr = this.tabsCurr.createCodeData;
            dataCurr.sendId = record.id;
            this.recordDetail = record;
            // 赋值
            if (record.content) this.welcomeData.push({
                id: 1,
                type: 'text',
                info: record.content,
                isShow: true
            });
            if (record.material) {
                const item = record.material;
                this.welcomeData.push({
                    id: item.mediaType === 'image' ? 2 : item.mediaType === 'link' ? 3 : item.mediaType === 'text' ? 5 : item.mediaType === 'file' ? 6 : 4,
                    type: item.mediaType,
                    info:
                        item.mediaType === 'image' || item.mediaType === 'wxapp'
                            ? item.cover
                            : (item.mediaType === 'link' ? (item.url ? item.url : item.title) : item.title),
                    isShow: true
                });
            } 
            this.createCode();
        },
        changePagination(e) {
            this.sendParams.page = e.current;
            this.getSendList();
        }
    }
}
</script>

<style>
#enterprise_send .page_content {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
}
#enterprise_send .tab_wrap .tab_title {
    margin-bottom: 15px;
    line-height: 1;
}
#enterprise_send .edit_code_title {
    border: 1px solid rgb(235, 237, 240);
    margin-bottom: 15px;
}
#enterprise_send .edit_code_from {
    padding-bottom: 60px;
}
#enterprise_send .from_btn {
    padding: 10px 0;
    width: 100%;
    background-color: #fff;
}
#enterprise_send .left_col {
    padding: 0 6% 0 0;
    width: calc(95% - 260px);
}
#enterprise_send .right_col {
    width: 260px;
}
#enterprise_send .from_btn_fix {
    /* position: fixed;
    right: 31px;
    bottom: 80px;
    width: calc(100% - 276px);
    padding: 10px 30px; */
}
#enterprise_send .affix_style,
#enterprise_send .affix_style>div {
    height: auto !important;
}
/* 列表 */
#enterprise_send .staff_list .select_btn {
    margin-bottom: 15px;
}
#enterprise_send .select_customer .title {
    width: 80px;
}
/* 详情 */
#enterprise_send .send_detail .ant-form-item {
    margin-bottom: 0;
}
</style>
